define([
	"dojo/_base/declare",
	"dojo/dom-attr",
	"dojo/dom-class",
	"dojo/keys",
	"dojo/query",
	"dojo/string",
	"./_ComboBoxMenu",
	"dijit/form/CheckBox",
	"dijit/registry",
	"csi",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/store/common",
	"csi/store/DelayedRequest",
	"csi/store/Names",
	"csi/xml",
], function(declare, domAttr, domClass, keys, query, string, _ComboBoxMenu, CheckBox, registry, csi, _, html, locale, {DISABLED_PROPERTY, EMPTY_GROUP_ITEM_PROPERTY}, {DelayedRequest}, Names, xml) {

	// special item, use example:
	// when user creates custom filter (ad hoc) we have to create new item in dropdown, which will represent this custom filter
	// it will require special processing later, so we mark this item by setting its type to TYPE_NEW_BUTTON
	const TYPE_NEW_BUTTON = "__addNewButton";

	return declare(_ComboBoxMenu, {
		// Array: contains list of exclusive item keys including clear all and non blanks
		_exclusiveItemKeys: [],

		onClick: function(/*DomNode*/node) {
			var targetNode = query("input", node);
			if (targetNode.length > 0) {
				var checkBoxNode = registry.byId(targetNode[0].id);
				if (checkBoxNode.value == this.ref.CLEARVALUE) {
					this.clearChecked();
				} else {
					if (!checkBoxNode.checked) {
						//fix for drop downs adding an empty value and still keeping the unchecked values
						//this happens only for newly added values
						this.value = _.without(this.value, checkBoxNode.value, "");
						this.ref.dropDown.value = this.value;
					}

					this.selectCurrentAttr(checkBoxNode.value);
				}
			} else {
				// do not do anything when disabled items are clicked
				if (!this._isDisabledSelection(node)) {
					this.inherited(arguments);
				}
			}
			this._updateRefValue();
		},

		/** Set value and update selection and placeholder */
		_updateRefValue: function() {
			this.ref.set("value", this.value, false);
			this.ref.checkedItems = this.value;
			this.ref._setCheckedValue();
			this.ref._setPlaceholderValue();
		},

		clearChecked: function(/*String*/excludeVal) {
			// This clears all checked values on the store
			var self = this;
			this.ref._resultStore.query({}).forEach(function(val) {
				excludeVal != val[self.ref.store.idProperty] && (val.checked = false);
			});
			_.each(this.domNode.childNodes, function(val, i) {
				const targetNodeList = query("input", val);
				const targetNode = targetNodeList[0];

				if (targetNodeList.length > 0 && targetNode.value != self.ref.CLEARVALUE) {
					// skip the one excluded and the one disabled
					if (excludeVal != targetNode.value && !targetNode.disabled) {
						registry.byId(targetNode.id).set('checked', false);
					}
				}
			});

			this.ref.initialSelection = false;
		},

		checkAllItems: function() {
			var self = this;
			//selectedValues contains list of selected item labels
			var selectedValues = [];
			//selectedItems contains list of seleced item values
			var selectedItems = [];
			var store = this.ref.store;

			dojo.forEach(this.items, function(val) {
				if (val[self.ref.searchAttr] != "" && val[self.ref.store.idProperty] != csi.DIALOG_URL && !val[self.ref.store.exclusiveProperty] && !_.contains(self._exclusiveItemKeys, val[self.ref.store.idProperty])) {
					selectedValues.push(val[self.ref.searchAttr]);
				}
			});

			this.selectedValues = _.union(this.selectedValues, selectedValues);

			_.each(this.domNode.childNodes, function(childNode, i) {
				if (!this._isDisabledSelection(childNode)) {
					var targetNode = query("input", childNode);

					if (targetNode.length > 0) {
						//check all checkboxes except exclusive items
						const val = targetNode[0].value;
						const id = targetNode[0].id;

						if (!_.contains(this._exclusiveItemKeys, val)) {
							registry.byId(id).set('checked', true);

							if (!store.bDelayedRequest && store.getFromMemory && !store.getFromMemory(val)) {
								this._addToStore(val);
							} else {
								selectedItems.push(val);
							}
						} else {
							registry.byId(id).set('checked', false);
						}
					}
				}
			}, this);

			this.value = _.union(_.difference(this.value, this._exclusiveItemKeys), selectedItems);

			this.ref.initialSelection = false;
			this._updateRefValue();
		},

		_getNewIndex: function(ref, val) {
			//creates new index for newly added values
			if (ref.store.indexProperty) {
				var indexBefore = null;
				var indexAfter = null;
				var index = 0;
				var sortedData = {};
				var storeData = ref._resultStore.query();

				//dojo store query sort dosen't work as expected so depending on underscore sort to sort the data
				if (storeData.length) {
					// C8-68440: name[ref.searchAttr] and value[ref.searchAttr] can be null in case of editing tags
					sortedData = _.sortBy(storeData, function(name) {
						return name[ref.searchAttr]?.toUpperCase();
					});
					_.each(sortedData, function(value) {
						if (value[ref.searchAttr]?.toLowerCase() < val.toLowerCase()) {
							indexBefore = value[ref.store.indexProperty];
						} else {
							indexAfter == null && (indexAfter = value[ref.store.indexProperty]);
						}
					});
				}

				index = indexBefore + ((indexAfter - indexBefore) / 2);
				null == indexBefore && (index = indexAfter - 1);
				null == indexAfter && (index = indexBefore + 1);
				return index;
			} else {
				return false;
			}
		},

		_addToStore: function(val) {
			// Adds new values to store and sets the status as checked
			var w = this.ref;

			val = val || w.textbox.value;

			if (w.ignoreCase) {
				val = val.toLowerCase();
			}

			var id = this.ref.showMatchEntry ? string.substitute(this.ref.queryExpr, [val]) : val;

			var dataItem = {};
			dataItem[w._newItemAttr] = true;
			dataItem[w.store.idProperty] = id;
			dataItem[w.searchAttr] = val;
			dataItem[w.labelAttr] = val;

			if (w.store.indexProperty) {
				dataItem[w.store.indexProperty] = this._getNewIndex(w, val);
			}

			if (w.store.put) {
				w.store.put(dataItem);
			}

			this.setCheckedValue(id);

			return id;
		},

		/**
		 * initialize this.selectedValues
		 */
		_initRefSelectedValues: function() {
			const selectedValues = [];

			this.ref._resultStore.query({}).forEach((val) => {
				if (_.contains(this.ref.value, val[this.ref.store.idProperty])) {
					selectedValues.push(val[this.ref.searchAttr]);
				}
			}, this);

			this.selectedValues = selectedValues;
			this.value = this.ref.value;
			this.ref.checkedValues = this.selectedValues;
		},

		_createOption: function(/*Object*/item, labelFunc) {
			// summary:
			//		Creates an option to appear on the popup menu subclassed by
			//		`dijit/form/FilteringSelect`.
			var menuitem = this.inherited(arguments),
				labelObject = labelFunc(item),
				chkBoxValue = null,
				checkCompareArray = [],
				checkedStatus = false;

			if (menuitem.classList.contains("csi-grouped-selection-suggested")) {
				return menuitem;
			}

			let invalidMenuItemContents = "";
			if (menuitem.classList.contains(html.CSS_INVALID_SELECTION)) {
				menuitem.classList.add("csi-invalid-selection-multi");
				invalidMenuItemContents = menuitem.innerHTML;
			}

			// removing menuitem text as it will be populated by checkbox and label
			menuitem.textContent = "";

			if (item[this.ref.store.idProperty] == csi.DIALOG_URL) {
				html.create("span", {innerText: item[this.ref.searchAttr]}, menuitem);
				menuitem.type = csi.DIALOG_URL;
				this.connect(menuitem, "onclick", "onclickPopup");
				return menuitem;
			} else if (item[this.ref.store.idProperty] === csi.MENU_ITEM_SEPARATOR) {
				const separator = html.create("div", {
					"class": csi.MENU_ITEM_SEPARATOR,
				});
				return separator;
			} else if (item[Names.ACTION_PROPERTY]) {
				html.create("span", {innerText: item[this.ref.searchAttr]}, menuitem);
				this.connect(menuitem, "onclick", "onclickNewAction");
				return menuitem;
			} else if (item[EMPTY_GROUP_ITEM_PROPERTY]) {
				// No Results case
				html.create("span", {innerText: item.name}, menuitem);
				return menuitem;
			}

			var htmlLabel;
			var textLabel;
			var checkBoxNode = html.create("span", {
				"class": "dijitCheckBoxNode"
			}, menuitem);

			_.each(_.flatten(this.ref.value), function(val) {
				checkCompareArray.push(val.toString());
			});

			const itemId = (item[this.ref.store.idProperty || this.ref.searchAttr]).toString();
			if (item.type !== TYPE_NEW_BUTTON) {
				// itemId might be undefined for item "No Results"
				checkedStatus = itemId ? _.contains(checkCompareArray, itemId) : false;

				if (((this.ref.value[0] && this.ref.value[0].toString() == "" && this.ref.value.length == 1) || this.ref.value.length == 0) && item[this.ref.store.idProperty] == this.ref.CLEARVALUE) {
					checkedStatus = true;
				}
			}

			var checkBox = new CheckBox({
				value: itemId ? itemId : "",
				checked: checkedStatus,
				disabled: !!item[DISABLED_PROPERTY],
				role: item.type
			}, checkBoxNode);

			if (item.type == TYPE_NEW_BUTTON) {
				textLabel = item[this.ref.searchAttr];
				chkBoxValue = item[this.ref.searchAttr];
				menuitem.title = locale.resource("MultiSelectAddTooltip");
				bHtml = false;
			} else {
				if (invalidMenuItemContents) {
					htmlLabel = invalidMenuItemContents;
				} else if (labelObject.html) {
					htmlLabel = labelObject.label;
				} else {
					textLabel = labelObject.label;
				}

				chkBoxValue = item[this.ref.store.idProperty];

				// add css class for exclusive item
				const {isDelayedSearch} = this.ref.store;
				const hasResults = !!this.ref.value.length;
				const isValueExclusive = (chkBoxValue === this.ref.CLEARVALUE) || (chkBoxValue === xml.VALUE_NONBLANK) || (chkBoxValue === xml.VALUE_BLANK) || this.ref.exclusiveItems[chkBoxValue];
				if ((hasResults || !isDelayedSearch) && isValueExclusive) {
					domClass.add(menuitem, "csiExclusiveCheckbox");
					if (chkBoxValue === xml.VALUE_NONBLANK) {
						domClass.add(menuitem, "csiExclusiveCheckboxNoSeparator");
					}
				}
			}

			if (checkedStatus) {
				if (!this.selectedValues) {
					if (this.ref.value) {
						this._initRefSelectedValues();
					} else {
						this.selectedValues = [item[this.ref.searchAttr]];
						this.value = [chkBoxValue];
					}
				}
			}

			html.create("label", {
				"class": "dijitMenuItemLabel" + (this.ref.includingIcon ? " csi-flex-inline" : ""),
				"for": checkBox.id,
				innerHTML: htmlLabel || "",
				innerText: textLabel
			}, menuitem);

			if (item.type == TYPE_NEW_BUTTON) {
				html.create("span", {
					"class": "dijitInline csiActionIcon material-icons",
					innerText: "add"
				}, menuitem);
				this.connect(menuitem, "onclick", "onclickAddNewItem");
			} else {
				this.connect(menuitem, "onclick", "onclickListOption");
			}

			return menuitem;
		},

		onHover: function(/*DomNode*/node) {
			this.inherited(arguments);
			if (node && node.lastChild && ((node.offsetWidth - 45) < node.lastChild.offsetWidth)) {
				// adds title tool-tip to menu item if text gets cropped
				node.title = node.textContent;
			}
		},

		selectCurrentAttr: function(val) {
			var selectedNode = this.selected,
				clickValue = null,
				chkBoxNode = null,
				filteredExclusiveKeys = _.difference(this._exclusiveItemKeys, this.ref.CLEARVALUE);

			if (this.m_selected) {
				//this section is to handle enter key
				selectedNode = this.m_selected;
				this.selected = this.m_selected;
				chkBoxNode = query("input", selectedNode);
				this.m_selected = null;
				if (chkBoxNode.length > 0) {
					clickValue = chkBoxNode[0].value;
					clickValue == this.ref.CLEARVALUE ? this.clearChecked() : this.setCheckBoxState(chkBoxNode[0]);

					if (domAttr.get(chkBoxNode[0], "role") == TYPE_NEW_BUTTON) {
						clickValue = this._addToStore(clickValue);
					} else {
						this.setCheckedValue(clickValue);
						this.ref.value = this.ref.checkedItems = this.value;
						this.ref._setCheckedValue();
						this.ref._setPlaceholderValue();
					}
				} else if (selectedNode.type && selectedNode.type == csi.DIALOG_URL) {
					clickValue = this.onclickPopup();
				}
			}

			//call clearChecked to clear all values only for exclusive values except "clear all" as it would have been cleared already on click function itself
			if (_.contains(filteredExclusiveKeys, val) || _.contains(filteredExclusiveKeys, clickValue)) {
				this.clearChecked(val || clickValue);
			}

			if (clickValue != this.ref.CLEARVALUE) {
				this._setSelectedAttr(selectedNode);
			}

			return clickValue;
		},

		handleKey: function(evt) {
			// summary:
			//		Handle keystroke event forwarded from ComboBox, returning false if it's
			//		a keystroke I recognize and process, true otherwise.
			// temporary storing of selected node for enter key
			this.m_selected = null;
			switch (evt.keyCode) {
				case keys.DOWN_ARROW:
					this.selectNextNode();
					return false;
				case keys.PAGE_DOWN:
					this._page(false);
					return false;
				case keys.UP_ARROW:
					this.selectPreviousNode();
					return false;
				case keys.PAGE_UP:
					this._page(true);
					return false;
				case keys.ENTER:
					this.m_selected = this.selected;
					break;
				default:
					return true;
			}
		},


		setCheckedValue: function(e, type) {
			const exclusiveChkBoxNode = {};
			const idProperty = this.ref.store.idProperty;

			if (this.selected) {
				_.each(this._exclusiveItemKeys, function(val) {
					exclusiveChkBoxNode[val] = query("input" + html.attributeSelector("value", val), this.selected.parentNode)[0];
				}, this);
			}

			this.ref.initialSelection = false;
			this.value = _.union(this.ref.value, this.value);
			this.selectedValues = _.union(this.ref.checkedValues, this.selectedValues);

			if (_.contains(this._exclusiveItemKeys, e) || e == this.ref.CLEARVALUE) {
				this.value = [];
				this.selectedValues = [];
				const chkBoxNode = query("input", this.selected)[0];
				//set value only if exclusive checkbox is selected, so exclusive checkboxes are not forced checked like CLEARVALUE the second time its clicked

				if (e != this.ref.CLEARVALUE && chkBoxNode.checked) {
					this.value.push(e);
					this.selectedValues.push(this.ref.exclusiveItems[e]);
				}
			} else {
				this.ref._resultStore.query({}).forEach(function(val) {
					if (val[idProperty] != null && val[idProperty].toString() == e) {
						if (_.contains(this.value, e)) {
							this.value = _.difference(this.value, _.isArray(e) ? e : [e]);
						} else {
							this.value = _.difference(this.value, this._exclusiveItemKeys);
							this.selectedValues = _.difference(this.selectedValues, _.values(this.ref.exclusiveItems));
							this.value.push(e);
							this.selectedValues.push(val[this.ref.searchAttr]);
						}
					}
				}, this);
			}

			if (_.size(exclusiveChkBoxNode) > 0) {
				if (this.value.length == 0) {
					exclusiveChkBoxNode[this.ref.CLEARVALUE] && registry.byId(exclusiveChkBoxNode[this.ref.CLEARVALUE].id).set('checked', true);
					this.selectedValues = [];

					// we need to keep the disabled items if any
					const {disableIds} = this.ref.store;

					if (disableIds) {
						// in some kinds of store, there's no disableUrls, for example, delay filtering store, enum store, ...
						for (const id of disableIds) {
							this.value.push(id);
							this.selectedValues.push(id);
						}
					}
				} else {
					_.each(this._exclusiveItemKeys, function(key) {
						exclusiveChkBoxNode[key] && registry.byId(exclusiveChkBoxNode[key].id).set('checked', e != this.ref.CLEARVALUE && e != key ? false : true);
					}, this);
				}
			}
		},

		/**
		 * Set state of checkbox targeted by event and return true if not disabled; otherwise, return false
		 * @param {Event} e 
		 * @return {boolean}
		 */
		setCheckBoxState: function(e) {
			const cb = registry.byId(e.id);

			if (cb && !cb.get("disabled")) {
				cb.set('checked', !e.checked);
				return true;
			}

			return false;
		},

		/**
		 * Set state of checkbox targeted by event (if not already the checkbox) and return value if not disabled; otherwise, return null
		 * @param {Event} e 
		 * @return {string|null}
		 */
		_clickCheckBoxEvent: function(e) {
			var targetNode = query("input", e.currentTarget)[0];

			if (e.target.nodeName != "INPUT") {
				if (!this.setCheckBoxState(targetNode)) {
					return null;
				}
			}

			return targetNode.value;
		},

		onclickPopup: function() {
			// store selections before overriding with Go to Dialog value; ideally we would have a specific callback to call to pass these
			// values back and invoke Go to Dialog, but for now this will have to do
			this.ref.preGoToDialogValue = this.value;
			this.ref.value = this.value = [csi.DIALOG_URL];

			// defer to allow time for widget to finish up processing (when ENTER used) before it gets destroyed
			_.defer(function(self) {
				self.ref.onSelectOption();
			}, this);

			return this.value;
		},

		/**
		 * Mark the New Action is being clicked 
		 */
		onclickNewAction: function() {
			this.ref.bClickNewAction = true;
			this.ref.onSelectOption();
		},

		onclickListOption: function(e) {
			var checkedValue = this._clickCheckBoxEvent(e);
			if (checkedValue !== null) {
				this.setCheckedValue(checkedValue);
				this.ref.focus();
			}

			e.stopPropagation();
			e.preventDefault();
		},

		onclickAddNewItem: function(e) {
			var newValue = this._clickCheckBoxEvent(e);
			if (this.ref.textbox.value != newValue) {
				//make sure widget textbox is populated with new value on multiple clicks
				this.ref.textbox.value = newValue;
			}

			this._addToStore();
			e.stopPropagation();
			e.preventDefault();
		},

		_addExclusiveItem: function(value, label) {
			//summary: adds an exclusive item to the dropdown to the top
			const {items, ref} = this;
			const {
				defaultAllPosition,
				exclusiveItems,
				labelAttr,
				searchAttr,
				store: {exclusiveProperty, idProperty, labelProperty}
			} = ref;

			const exclusiveItem = {
				[idProperty]: value,
				[labelAttr || labelProperty]: label,
				[searchAttr || searchProperty]: label,
				[exclusiveProperty]: true,
			};

			// insert exclusive item to items array based on defaultAllPosition
			items.splice(defaultAllPosition, 0, exclusiveItem);
			exclusiveItems[value] = label;
		},

		createOptions: function(results, options, labelFunc) {
			// summary:
			//		Fills in the items in the drop down list
			// results:
			//		Array of items
			// options:
			//		The options to the query function of the store
			//
			// labelFunc:
			//		Function to produce a label in the drop down list from a dojo.data item
			this.items = results;

			// remove exclusive items before recreating them
			// this is TODO until Jabili decide on DelayedSearch CMS design
			this.clearResultList(true);

			// display "Previous . . ." button
			this.previousButton.style.display = (options.start == 0) ? "none" : "";
			domAttr.set(this.previousButton, "id", this.id + "_prev");
			// create options using _createOption function defined by parent
			// ComboBox (or FilteringSelect) class
			// #2309:
			//		iterate over cache nondestructively
			var store = this.ref.store;

			if (this.ref.addItemAll) {
				//add "All" as an exclusive item
				this._addExclusiveItem(this.ref.ALLVALUE, this.ref._getSelectAllText());
			}

			if (this.ref.showClearField && !_.contains(_.pluck(this.items, 'type'), TYPE_NEW_BUTTON) && !this.ref._resultStore.hideAll) {
				//add clear as an exclusive item
				this._addExclusiveItem(this.ref.CLEARVALUE, this.ref._getDefaultClearText());
			}

			this._exclusiveItemKeys = _.keys(this.ref.exclusiveItems);

			_.each(results, function(item, i) {
				if (this.ref.labelFunc(item, store) && !_.contains(this.ref.excludeValues, item[store.idProperty])) {
					var menuitem = this._createOption(item, labelFunc);
					menuitem.setAttribute("item", i); // index to this.items; use indirection to avoid mem leak
					domAttr.set(menuitem, "id", this.id + i);
					this.nextButton.parentNode.insertBefore(menuitem, this.nextButton);
				}
			}, this);

			// in case of delayed search selectedValues will be not initialized until first user search - we have to initialize it 
			if (this.delayedStore && !this.selectedValues) {
				if (this.ref.value) {
					this._initRefSelectedValues();
				}
			}

			// display "Next . . ." button
			this.nextButton.style.display = results.displayMore ? "" : "none";
			domAttr.set(this.nextButton, "id", this.id + "_next");
			domClass.add(this.containerNode, "multiSelectMenu");
		},

		// override dijit function to preserve ALL/NONE items.
		// this is TODO until Jabili decide on DelayedSearch CMS design
		clearResultList: function(clearExclusiveItems) {
			// summary:
			//		Clears the entries in the drop down list, but of course keeps the previous and next buttons.
			var container = this.containerNode;
			let excludeItemNum = 2 + (clearExclusiveItems ? 0 : this._exclusiveItemKeys.length);
			while (container.childNodes.length > excludeItemNum) {
				container.removeChild(container.childNodes[container.childNodes.length - 2]);
			}
			this._setSelectedAttr(null);
		},


	});
});
